import axios from "axios";

export default {
    //#region LOGS
    
    getLogTypes() {
        return axios.get("/api/logs/get-log-types", {withCredentials: true});
    },

    getLogs(_, params) {
        return axios.get(`/api/logs/get-logs/${params.company_id}/${params.page}`, {withCredentials: true});
    },

    //#endregion LOGS

    //#region USER PERMISSIONS

    getUserPermissions(_, params) {
        return axios.post("/api/userpermission/getuserpermissions", params, {withCredentials: true});
    },

    createUserPermission(_, params) {
        return axios.post("/api/userpermission/createuserpermission", params, {withCredentials: true});
    },

    updateUserPermission(_, params) {
        return axios.post(`/api/userpermission/getuserpermission/${params.user_permission_id}`, params, {withCredentials: true});
    },

    deleteUserPermission(_, params) {
        return axios.post("/api/userpermission/deleteuserpermission", params, {withCredentials: true});
    },

    getAssignedUserPermissions(_, params) {
        return axios.post("/api/assignedcompanypermission/getassigneduserpermissions", params, {withCredentials: true});
    },

    getAssignedUserPermissionsByUserID(_, params) {
        return axios.post("/api/assignedcompanypermission/getassigneduserpermissionsbyuserid", params, {withCredentials: true});
    },

    createAssignedUserPermission(_, params) {
        return axios.post("/api/assignedcompanypermission/createassigneduserpermission", params, {withCredentials: true});
    },

    updateAssignedUserPermission(_, params) {
        return axios.post(`/api/assignedcompanypermission/updateassigneduserpermission/${params.assigned_user_permission_id}`, params, {withCredentials: true});
    },

    deleteAssignedUserPermission(_, params) {
        return axios.post("/api/assignedcompanypermission/deleteassigneduserpermission", params, {withCredentials: true});
    },

    getAssignedUserPermissionsByCompany(_, params) {
        return axios.post("/api/assigneduserpermission/getassigneduserpermissionsbycompanyid", params, {withCredentials: true});
    },
    
    updateAssignedUserPermissionByRole(_, params) {
        return axios.post("/api/assigneduserpermission/updateassigneduserpermissionsofcompanybyrole", params, {withCredentials: true});
    },
    
    //#endregion USER PERMISSONS

    //#region COMPANY PERMISSONS

    getCompanyPermissions(_, params) {
        return axios.post("/api/companypermission/getcompanypermissions", params, {withCredentials: true});
    },

    createCompanyPermission(_, params) {
        return axios.post("/api/companypermission/createcompanypermission", params, {withCredentials: true});
    },

    updateCompanyPermission(_, params) {
        return axios.post(`/api/companypermission/getcompanypermission/${params.company_permission_id}`, params, {withCredentials: true});
    },

    deleteCompanyPermission(_, params) {
        return axios.post("/api/companypermission/deletecompanypermission", params, {withCredentials: true});
    },

    getAssignedCompanyPermissionsByCompany(_, params) {
        return axios.post("/api/assignedcompanypermission/getassignedcompanypermissionsbycompanyid", params, {withCredentials: true});
    },

    createAssignedCompanyPermission(_, params) {
        return axios.post("/api/assignedcompanypermission/createassignedcompanypermission", params, {withCredentials: true});
    },

    updateAssignedCompanyPermission(_, params) {
        return axios.post(`/api/assignedcompanypermission/updateassignedcompanypermission/${params.assigned_company_permission_id}`, params, {withCredentials: true});
    },

    deleteAssignedCompanyPermission(_, params) {
        return axios.post("/api/assignedcompanypermission/deleteassignedcompanypermission", params, {withCredentials: true});
    },

    //#endregion COMPANY PERMISSONS

    //#region CARBON PROFILE

    getTermsAndStatesInputs(_) {
        return axios.get(`/api/carbon/getcarbontermsandstatesinputs`, {withCredentials: true});
    },

    updateTermsAndStates(_, params) {
        let body = {};
        for (const key in params) {
            if (Object.hasOwnProperty.call(params, key)) {
                const element = params[key];
                
                if (key != "carbon_terms_states_input_id") {
                    body[key] = element;
                }
            }
        }

        return axios.post(`/api/carbon/updatecarbontermsandstatesinput/${params.carbon_terms_states_input_id}`, body, {withCredentials: true});
    },

    //#endregion CARBON PROFILE

    //#region FACILITIES

    getCompaniesWithFacilityCounts(_, params) {
        return axios.post(`/api/facility/getcompanieswithfacilitycounts`, params, {withCredentials: true});
    },

    updateFacilitySlotsOfCompany(_, params) {
        return axios.post(`/api/facility/updatefacilityslotsofcompany`, params, {withCredentials: true});
    },

    //#endregion FACILITIES

    //#region METRIC ASSIGNMENTS
    
    getGroupedMetrics(_, params) {
        return axios.get(`/api/input/get-grouped-metrics/${params.category_id}/${params.facility_id}`, {withCredentials: true});
    },
    
    getCompanyOfficers(_) {
        return axios.get(`/api/company/get-company-officers`, {withCredentials: true});
    },

    checkHasAssignment(_) {
        return axios.get(`/api/input/check-has-assignment`, {withCredentials: true});
    },

    handleMetricAssignment(_, params) {
        return axios.post(`/api/input/handle-metric-assignment/${params.type}`, params.body, {withCredentials: true});
    },

    deleteMetricAssignment(_, params) {
        return axios.delete(`/api/input/delete-metric-assignment/${params.user_id}/${params.facility_id}/${params.metric_id}/${params.type}`, {withCredentials: true});
    },

    revokeAllAssignments(_, params) {
        return axios.delete(`/api/input/revoke-all-assignments/${params.user_id}/${params.facility_id}/${params.type}`, {withCredentials: true});
    },

    getSupplierMetricRequestsByCategory(_, params) {
        return axios.get(`/api/input/supplier-metric-requests/${params.category_id}`, {withCredentials: true});
    },

    // Single toggle (primary, supplier, metric). Body: { metric_kpi_id, supplier_company_id, on, all, from_year }.
    // When `all` is true, toggles the "all suppliers" wildcard instead of a single supplier.
    toggleSupplierMetricRequest(_, params) {
        return axios.post(`/api/input/supplier-metric-requests/toggle`, params, {withCredentials: true});
    },

    // Sets the single primary-wide "from year" on every active request. Body: { from_year }.
    setSupplierMetricRequestsFromYear(_, params) {
        return axios.post(`/api/input/supplier-metric-requests/set-from-year`, params, {withCredentials: true});
    },

    // Body: { supplier_company_ids: [...] }. Fires one generic "new KPI inputs" notification per listed supplier.
    notifySuppliersOfRequests(_, params) {
        return axios.post(`/api/input/supplier-metric-requests/notify`, params, {withCredentials: true});
    },

    //#endregion METRIC ASSIGNMENTS

    //#region APP STATES

    getAppStates() {
        return axios.get(`/api/app-state/app-states`, {withCredentials: true});
    },
    
    getAppState() {
        return axios.get(`/api/app-state/app-state`, {withCredentials: false});
    },

    createAppState(_, params) {
        return axios.post(`/api/app-state/app-state`, params, {withCredentials: true});
    },

    updateAppState(_, params) {
        return axios.patch(`/api/app-state/app-state/${params.id}`, params.body, {withCredentials: true});
    },

    deleteAppState(_, params) {
        return axios.delete(`/api/app-state/app-state/${params.id}`, {withCredentials: true});
    },

    //#endregion APP STATES

}